import React, { useState } from "react";
import "./index.css";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ReportHeader = ({
  handleClick = () => { },
  title = "",
  year = "",
  report = "",
  logo = "/assets/images/adminLogo.png"
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate()
  const open = Boolean(anchorEl);

  const dowloadReportAs = [
    {
      id: 1,
      name: "Download as PDF",
    },
    {
      id: 2,
      name: "Download as XLS",
    },
    {
      id: 3,
      name: "Download as CSV",
    },
  ];

  const handleDownload = (event) => {
    setAnchorEl(event.currentTarget);
  };


  const handleTitlevalue = () => {
    switch (report) {
      case "Report_1a_Large":
        return "Table 1A"
      case "Report_1a_Small":
        return "Table 1B"
      case "Report_1a_CCA":
        return "Table 1C"
      case "Report_2a_TotalSpend":
        return "Table 2A"
      case "Report_2a_Subcontracting":
        return "Table 2B"
      case "Report_3a_Large":
        return "Table 3A"
      case "Report_3b_Small":
        return "Table 3B"
      case "Report_3c_Large":
        return "Table 3C"
      case "Report_3d_Small":
        return "Table 3D"
      case "Report_4a_Large":
        return "Table 4A"
      case "Report_4b_Small":
        return "Table 4B"
      case "Report_5a_DVBE":
        return "Table 5A"
      case "Report_5a_LGBTBE":
        return "Table 5B"
      case "Report_6_DIRECT_BY_YEAR":
        return "Table 6"
      default:
        return "Table";
    }
  }

   // { value: 'Report_5a_DVBE', label: 'Report 5A DVBE' },
    // { value: 'Report_5b_LGBTBE', label: 'Report 5B LGBTBE'},

  const handleClose = () => {
    setAnchorEl(null);
  };

  const accessToken = localStorage.getItem("access_token");

  let loginRole = null;

  if (accessToken) {
    try {
      const parsedToken = JSON.parse(accessToken);
      loginRole = parsedToken.role;
    } catch (error) {
    }
  }


  return (
    <div className='report_header'>
      <div className='logo_rep_head'>
        <img src={logo} alt='logo.png' style={{ height: "68px", width: "68px", borderRadius: "50%" }} />
      </div>
      <div className='header_text'>
        <div className='table_number'>
          <p>{handleTitlevalue()}</p>
        </div>
        <div className='table_desc1'>{report=== "Report_6_DIRECT_BY_YEAR" ? year : `${year} ${title}`}</div>
        <div className='table_desc2'>{report=== "Report_6_DIRECT_BY_YEAR" ? "Direct By Years" : "in Dollars and as a Percentage of Total Corporate Procurement"}</div>
      </div>
      <div className='download_report_button1' onClick={()=>navigate(-1)}>
        <button>
          <p>Back</p>
        </button>
      </div>
      <div className='download_report_button'>
        <button
          onClick={(event) => {
            event.stopPropagation();
            handleDownload(event);
          }}>
          <p>Download Report</p>
          <img src='/assets/images/DownloadVector.png' alt='download_logo.png' />
        </button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          autoFocus={false}
          sx={{
            "& .MuiPaper-root": {
              minWidth: "11.042vw",
              borderRadius: "8px",
              border: "1px solid #CCCCCC",
              marginTop: "5px",
              marginLeft: "-29px",
            },
            "& .MuiList-root": {
              padding: "0px",
            },
          }}>
          {dowloadReportAs.map((item, index) => (
            <MenuItem
              key={index}
              style={{
                border: "1px solid #E6E6E6",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                cursor: "pointer",
              }}
              onClick={() => handleClick(item.id)}
              sx={{
                padding: "16px",
              }}>
              {/* {item.id === 1 ? <img src={item.icon} alt={`${item.name} Icon`} /> : item.icon} */}
              {item.name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    </div>
  );
};

export default ReportHeader;
